export const diskImages: DiskCollectionItem[] = [
  {
    title: "Autoduel",
    diskUrl: {
      s6d1: "https://archive.org/download/wozaday_Autoduel/Autoduel%20%28woz-a-day%20collection%29.zip/Autoduel%20%28woz-a-day%20collection%29%2FAutoduel%20side%20A.woz",
      s6d2: "https://archive.org/download/wozaday_Autoduel/Autoduel%20%28woz-a-day%20collection%29.zip/Autoduel%20%28woz-a-day%20collection%29%2FAutoduel%20side%20B.woz",
    },
    imageUrl: "disks/autoduel.png",
    detailsUrl: "https://www.mobygames.com/game/1296/autoduel",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 246574,
  },
  {
    title: "Aztec",
    diskUrl: "Aztec.woz",
    imageUrl: "disks/Aztec.png",
    detailsUrl: "https://www.mobygames.com/game/13259/aztec/",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 234496
  },
  {
    title: "Eamon",
    diskUrl: "Eamon%201.po",
    helpFile: "Eamon 1.txt",
    imageUrl: "disks/Eamon%201.png",
    detailsUrl: "https://eamon.wiki/Source:Eamon_Player%27s_Manual_(revised)",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 819200
  },
  // {
  //   title: "Apple IIe Diagnostic",
  //   diskUrl: "Apple IIe Diagnostic 2.1.po",
  //   imageUrl: "disks/Apple IIe Diagnostic 2.1.png",
  //   type: undefined,
  //   lastUpdated: new Date(0),
  // },
  {
    title: "MECC Inspector",
    diskUrl: "MECC-Inspector.woz",
    imageUrl: "disks/MECC-Inspector.png",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 234496
  },
  {
    title: "MousePaint",
    diskUrl: "MousePaint.woz",
    imageUrl: "disks/MousePaint.png",
    type: "builtin",
    lastUpdated: new Date(0),
    params: "color=white",
    fileSize: 234496
  },
  {
    title: "Nox Archaist Demo",
    diskUrl: "Nox%20Archaist%20Demo.hdv",
    imageUrl: "disks/Nox%20Archaist%20Demo.png",
    detailsUrl: "https://noxarchaist.com",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 1474560
  },
  {
    title: "Olympic Decathalon",
    diskUrl: "Olympic%20Decathlon.woz",
    imageUrl: "disks/Olympic%20Decathlon.png",
    detailsUrl: "https://archive.org/details/microsoft-olympic-decathlon-a2-ph/",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 234496
  },
  {
    title: "Print Shop Color",
    diskUrl: "Print%20Shop%20Color.po",
    imageUrl: "disks/Print%20Shop%20Color.png",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 234757
  },
  {
    title: "ProDOS 2.4.3",
    diskUrl: "ProDOS%202.4.3.po",
    imageUrl: "disks/ProDOS%202.4.3.png",
    detailsUrl: "https://prodos8.com/",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 143360
  },
  {
    title: "Robotron",
    diskUrl: "Robotron4Joy.po",
    imageUrl: "disks/Robotron4Joy.png",
    detailsUrl: "https://groups.google.com/g/comp.sys.apple2/c/2xlihijn82o/",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 143360
  },
  {
    title: "Total Replay",
    diskUrl: "https://ct6502.org/wp-content/uploads/2026/06/TotalReplay.hdv_.zip",
    helpFile: "TotalReplay.txt",
    // diskUrl: "TotalReplay.hdv",
    // diskUrl: "https://archive.org/download/TotalReplay/Total%20Replay%20v5.2.hdv",
    imageUrl: "disks/Total%20Replay.png",
    detailsUrl: "https://archive.org/details/TotalReplay",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 33553920,
    params: "slot3=vidhd",
  },
  {
    title: "Instant Replay",
    diskUrl: "https://ct6502.org/wp-content/uploads/2026/01/TotalReplayII.hdv_.zip",
    helpFile: "TotalReplayII.txt",
    // diskUrl: "https://archive.org/download/TotalReplay2/Total%20Replay%20II%20v1.0-alpha.4.hdv",
    imageUrl: "disks/Instant%20Replay.png",
    detailsUrl: "https://github.com/a2-4am/4sports",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 33553920,
  },
  {
    title: "Pitch Dark",
    diskUrl: "https://github.com/anomixer/pitch-dark/releases/download/R6/Pitch_Dark.hdv.zip",
    helpFile: "PitchDark.txt",
    // diskUrl: "https://archive.org/download/PitchDark/00playable.hdv",
    imageUrl: "disks/Pitch%20Dark.png",
    detailsUrl: "https://github.com/anomixer/pitch-dark/releases",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 33553920,
    params: "slot3=vidhd",
  },
  {
    title: "Tass Times in Tonetown",
    diskUrl: "Tass Times.2mg",
    imageUrl: "disks/Tass%20Times.png",
    detailsUrl: "https://www.mobygames.com/game/90/tass-times-in-tonetown/",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 819264,
    params: "color=nofringe",
  },
  {
    title: "Ultima III",
    disks: {
      s6d1: [
        "https://archive.org/download/wozaday_Ultima_III_Exodus/Ultima%20III%20%28woz-a-day%20collection%29.zip/Ultima%20III%20%28woz-a-day%20collection%29%2FUltima%20III%20side%20A.woz|Program Disk",
        "Ultima III side B.woz|Scenario Disk",
      ],
    },
    imageUrl: "disks/Ultima III.png",
    detailsUrl: "https://wiki.ultimacodex.com/wiki/Ultima_III:_Exodus",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 236402,
  },
  {
    title: "Ultima IV",
    diskUrl: "Ultima%20IV.hdv",
    imageUrl: "disks/Ultima%20IV.png",
    detailsUrl: "https://wiki.ultimacodex.com/wiki/Ultima_IV:_Quest_of_the_Avatar",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 819200
  },
  {
    title: "Ultima V",
    diskUrl: "Ultima%20V.hdv",
    imageUrl: "disks/Ultima%20V.png",
    detailsUrl: "https://wiki.ultimacodex.com/wiki/Ultima_V:_Warriors_of_Destiny",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 1474560
  },
  {
    title: "Wizard Replay",
    diskUrl: "https://ct6502.org/wp-content/uploads/2026/01/WizardReplay.hdv_.zip",
    helpFile: "WizardReplay.txt",
    // diskUrl: "https://archive.org/download/WizardReplay/Wizard%20Replay%20v2.0.hdv",
    imageUrl: "disks/WizardReplay.png",
    detailsUrl: "https://archive.org/details/WizardReplay",
    type: "builtin",
    lastUpdated: new Date(0),
    fileSize: 33553920
  },
]

export const internalDiskResources = [
  {
    diskUrl: "blank.woz",
    helpFile: "blank.txt"
  }
]
